module.exports = __webpack_public_path__ + "static/media/record.09f6739b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/dashboard-icons/record.svg
// module id = 2120
// module chunks = 0